<template>
  <div>
    <px-view-header title="Aprovações de solicitação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>

    <px-aprovacao-solicitacao-header :on-click-refresh="onClickRefresh"
                                     @change="onChange"/>
    <px-aprovacao-solicitacao-list v-if="selectedStatus" ref="aprovacoesList" class="mt-3"/>
<!--    modal para abrir uma solicitação vinda da URL -->
    <px-aprovacao-solicitacao-detalhes-modal-view ref="modalAprovacao"
                                                  :aprovacao-id="aprovacaoId"
                                                  @update="onClickRefresh">
      <template v-slot:activator>
        <span></span>
      </template>
    </px-aprovacao-solicitacao-detalhes-modal-view>
  </div>
</template>

<script>
import AprovacaoSolicitacaoHeader
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoHeader.vue';
import AprovacaoSolicitacaoList from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoList.vue';
import { mapGetters } from 'vuex';
import pxAprovacaoSolicitacaoDetalhesModalView
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhesModalView.vue';

export default {
  data() {
    return {
      aprovacaoId: this.$route.query.id,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Aprovações de solicitação',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemAprovacaoSolicitacao', ['selectedStatus']),
  },
  methods: {
    onClickRefresh() {
      this.$refs.aprovacoesList.refresh();
    },
    onChange() {
      this.$refs.aprovacoesList.onChangeFilters();
    },
  },
  mounted() {
    if (this.aprovacaoId) {
      this.$refs.modalAprovacao.open();
    }
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesModalView,
    pxAprovacaoSolicitacaoHeader: AprovacaoSolicitacaoHeader,
    pxAprovacaoSolicitacaoList: AprovacaoSolicitacaoList,
  },
};
</script>
